import {REGIONEAEREOPARTENZA} from './regioneAereoPartenzaTypes'

export const changeRegioneAereoPartenza = regioneAereoPartenza => {
    return {
        type: REGIONEAEREOPARTENZA,
        load: regioneAereoPartenza
    }
}

export const selectNewRegioneAereoPartenza = (regioneAereoPartenza) => {

    return (dispatch) => {
        dispatch(changeRegioneAereoPartenza(regioneAereoPartenza))
    }

}